/** TLV 18/03/2020
* @fn createForeignIban
* @brief Fonction permettant de créer un "faux" iban en base selon le codage proposé pour chaque pays
* @param zone est l'objet json correspondant dans le fichiers bankAccounts.js dans l'engine
*/
export const createForeignIban = (zone) => {
  let firstBankData = zone.values[zone.accountLabel[0]]
  let secondBankData = zone.values[zone.accountLabel[1]] != null ? zone.values[zone.accountLabel[1]] : ''
  let zoneMatchings = {
    'EUR': firstBankData,
    'GBP': 'GB00XXXX' + firstBankData.padStart(6, '0') + secondBankData.padStart(8, '0'),
    'USD': 'US00XXXXXXXXX' + firstBankData.padStart(9, '0'),
    'AUD': 'AU00XXXXXXXXXXXX' + firstBankData.padStart(6, '0')
  }
  return zoneMatchings[zone.label]
}

/** TLV 18/03/2020
* @fn extractForeignIban
* @brief Fonction permettant de récupérer les données bancaires correspondantes à partir du "faux IBAN" stocké en base
* @param zone est l'abréviation de la zone géographique (EU, UK, etc)
* @param iban est la chaîne de caractère stockée en base regroupant ces données bancaires
*/
export const extractForeignIban = (iban, zone) => {
  let zoneMatchings = {
    'EUR': {
      iban: {
        labelId: 'common.ibn',
        value: iban,
        hiddenValue: iban.slice(-4).padStart(iban.length, 'X')
      }
    },
    'GBP': {
      sortCode: {
        labelId: 'common.srt_code',
        value: iban.substring(8, 14),
        hiddenValue: 'XX-XX-' + iban.substring(12, 14)
      },
      accountNumber: {
        labelId: 'common.act_nbr',
        value: iban.substring(14, 22),
        hiddenValue: 'XXXX' + iban.substring(18, 22)
      }
    },
    'USD': {
      aba: {
        labelId: 'common.aba',
        value: iban.substring(13, 22),
        hiddenValue: 'XXXXXX' + iban.substring(19, 22)
      }
    },
    'AUD': {
      bsb: {
        labelId: 'common.bsb',
        value: iban.substring(16, 22),
        hiddenValue: 'XXXX' + iban.substring(20, 22)
      }
    }
  }
  return zoneMatchings[zone]
}

// Retour temporaire de ces fonctions inutiles sur long terme, le temps de finir les multidevises
export const createIbanUK = (sort, account) => {
  return 'GB00XXXX' + sort.padStart(6, '0') + account.padStart(8, '0')
}

export const extractIbanUK = (iban) => {
  return {
    sortCode: iban.substring(8, 14),
    accountNumber: iban.substring(14, 22)
  }
}

export const formatIbanUK = (iban) => {
  return iban.substring(8, 10) + '-' + iban.substring(10, 12) + '-' + iban.substring(12, 14) + ' ' + iban.substring(14, 22)
}

export const formatIbanUKHidden = (iban) => {
  return 'XX-XX-' + iban.substring(12, 14) + ' XXXX' + iban.substring(18, 22)
}

export const formatIbanHidden = (iban) => {
  let len = iban.length
  let show = iban.substring(len - 4, len)
  return show.padStart(len, 'X')
}

export const capitalizeFirstLetter = ([first, ...rest]) => {
  return [ first.toUpperCase(), ...rest ].join('')
}



// WEBPACK FOOTER //
// ./src/helpers/format.js